import { defineComponent as o, computed as t } from "vue";
import { getFullId as i } from "./index561.js";
const u = o({
  name: "MsAdPlace",
  props: {
    isSticky: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    alwaysVisible: {
      type: Boolean,
      default: !1
    },
    isInDisturber: {
      type: Boolean,
      default: !1
    },
    height: {
      type: [Number, String],
      default: null
    },
    placementId: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const l = t(() => e.height ? e.height + "px" : void 0), a = t(() => i(e.placementId));
    return {
      computedHeight: l,
      computedHBId: a
    };
  }
});
export {
  u as default
};
